import durationToStr from '@/libs/utils/durationToStr'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useState } from 'react'
import FullscreenControl from './FullscreenControl'
import PlayControl from './PlayControl'
import SeekBar from './SeekBar'
import VolumeControl from './VolumeControl'

const getTimes = ({ duration, playedSeconds }) => {
  const totalStr = durationToStr(duration)
  const playedStr = durationToStr(playedSeconds, duration)

  return { totalStr, playedStr }
}

const PlayerControls = ({
  playing,
  setPlaying,
  playedSeconds,
  duration,
  muted,
  setMuted,
  volume,
  setVolume,
  parentRef,
  playerRef,
  isFullscreen,
  onSeek: propsOnSeek,
}) => {
  const durations = getTimes({ duration, playedSeconds })
  const [showVolume, setShowVolume] = useState(false)

  const seekbarTimeFormat = value => durationToStr(value, duration)

  const onSeek = value => {
    if (value < playedSeconds) {
      playerRef.current.seekTo(value, 'seconds')
      propsOnSeek?.()
    }
  }

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        display: 'flex',
        alignItems: 'flex-end',
      }}
    >
      <Box
        sx={{
          flex: 1,
          background: 'linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(255,255,255,0) 100%)',
          display: 'flex',
          alignItems: 'center',
          height: 50,
          padding: 2,
          color: theme => theme.palette.other.white.main,
        }}
      >
        <PlayControl playing={playing} setPlaying={setPlaying} />
        <Box sx={{ mx: 1 }}>
          <VolumeControl
            muted={muted}
            setMuted={setMuted}
            volume={volume}
            setVolume={setVolume}
            showVolume={showVolume}
            setShowVolume={setShowVolume}
          />
        </Box>
        {!showVolume && (
          <Typography variant="overline" sx={{ ml: 1 }}>
            {`${durations.playedStr} / ${durations.totalStr}`}
          </Typography>
        )}
        <SeekBar
          seekbarTimeFormat={seekbarTimeFormat}
          onSeek={onSeek}
          value={playedSeconds}
          max={duration}
          containerProps={{ sx: { flex: 1, ml: 2 } }}
        />
        <FullscreenControl parentRef={parentRef} isFullscreen={isFullscreen} />
      </Box>
    </Box>
  )
}

export default PlayerControls
